import { dsusaveChecklist } from "../../new-rep-application-interfaces/checklist.interface";
export class MnchecklistModel {
  private mnchecklist!: dsusaveChecklist[];
  private pias_rep_code!: string;
  private bscGrade!: string;
  private bscSatisfactory!: string;
  private bscGrade1!: string;
  private bscSatisfactory1!: string;

  constructor() { }

  getmnChecklist() {
    return this.mnchecklist;
  }

  setmnChecklist(data: dsusaveChecklist[]) {
    this.mnchecklist = data;
  }

  getpias_rep_code(): string {
    return this.pias_rep_code;
  }

  setpias_rep_code(pias_rep_code: string) {
    this.pias_rep_code = pias_rep_code;
  }

  getBscGrade(): string {
    return this.bscGrade;
  }

  setBscGrade(bscGrade: string) {
    this.bscGrade = bscGrade;
  }

  getBscSatisfactory(): string {
    return this.bscSatisfactory
  }
  setBscSatisfactory(bscSatisfactory: string) {
    this.bscSatisfactory = bscSatisfactory;
  }

  getBscGrade1(): string {
    return this.bscGrade1;
  }

  setBscGrade1(bscGrade1: string) {
    this.bscGrade1 = bscGrade1;
  }

  getBscSatisfactory1(): string {
    return this.bscSatisfactory1
  }
  setBscSatisfactory1(bscSatisfactory1: string) {
    this.bscSatisfactory1 = bscSatisfactory1;
  }

  toString() {
    return JSON.stringify({
      pias_rep_code:this.getpias_rep_code(),
      checklist: this.getmnChecklist(),
      grade_details: {
        bscGrade: this.getBscGrade(),
        bscSatisfactory: this.getBscSatisfactory(),
        bscGrade1: this.getBscGrade1(),
        bscSatisfactory1: this.getBscSatisfactory1(),
      }
    })
  }
}
